import { configureStore, combineReducers } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"

import authSliceReducer from "../slices/authSlice"

// Custom storage adapter — redux-persist/lib/storage doesn't resolve with Bun's bundler
const storage = {
  getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
  setItem: (key: string, value: string) => Promise.resolve(localStorage.setItem(key, value)),
  removeItem: (key: string) => Promise.resolve(localStorage.removeItem(key)),
}

// ----------------------------------------------------------------------------

const reducers = combineReducers({
  auth: authSliceReducer,
})

const persistConfig = {
  key: "cogeser-backoffice",
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
})

const persistor = persistStore(store)

// ----------------------------------------------------------------------------

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { persistor }
export default store
